import React, { useContext } from 'react';
import './App.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import NavBar from './NavBar';
import Home from './pages/Home';
import YourData from './pages/YourData';
import Analysis from './pages/Analysis';
import Sessions from './pages/Sessions';
import Profile from './pages/Profile';
import Reports from './pages/Reports';
import SessionAnalysis from './pages/SessionAnalysis';
import Landing from './pages/Landing';
import Experiments from './pages/Experiments';
import AdminHome from './pages/AdminHome';
import BehavioralTracking from './pages/BehavioralTracking';
import { AuthContext } from './contexts/AuthContext';
import AdminRoute from './components/AdminRoute';
import PrivacyPolicyToS from './pages/PrivacyPolicyToS';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

const ProtectedRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  return user ? children : <Navigate to="/" />;
};

const App = () => {
  return (
    <div className="App">
      <NavBar />
      <Routes>
        {/* Public Route */} 
        <Route path="/" element={<Landing />} />
        <Route path="/PrivacyPolicyToS" element={<PrivacyPolicyToS />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/TermsOfService" element={<TermsOfService />} />
        {/* Protected Routes */} 
        <Route path="/adminHome" element={<AdminRoute><AdminHome /></AdminRoute>} />
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/yourData" element={<ProtectedRoute><YourData /></ProtectedRoute>} />
        <Route path="/analysis" element={<ProtectedRoute><Analysis /></ProtectedRoute>} />
        <Route path="/sessions" element={<ProtectedRoute><Sessions /></ProtectedRoute>} />
        <Route path="/sessionAnalysis" element={<ProtectedRoute><SessionAnalysis /></ProtectedRoute>} />
        <Route path="/experiments" element={<ProtectedRoute><Experiments /></ProtectedRoute>} />
        <Route path="behavioralTracking" element={<ProtectedRoute><BehavioralTracking /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

        {/* 👇 Catch-all route for unknown URLs */}
        <Route path="*" element={<Navigate to="/home" />} /> 
      </Routes>
    </div>
  );
};

export default App;
